/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="attribute-wrapper">
    <div class="attribute-row">
      <span class="label" v-show="attribute.label">{{ attribute.label }}: </span>
      <span class="value" :class="[`value-${attribute.key}`]">{{ productCode }}</span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'AccordionProductCode',
  props: {
    attribute: {
      type: Object,
      required: true
    },
    product: {
      type: Object,
      required: true
    },
    variantSelected: {
      type: Array | Object,
      required: false
    }
  },
  computed: {
    productCode () {
      if (Array.isArray(this.variantSelected) && this.variantSelected.length === 1) {
        return this.variantSelected[0].sku
      } else {
        return this.attribute.value
      }
    }
  }
}
</script>
